import { Country } from '@afterpay/types'

export interface NewUserPromoDetail {
  merchantId: number
  promoId: string
  region: Country
  offerName: string
  discountAmount: string
  minimumSpend: string
  startDate?: string
  endDate?: string
}

export const NEW_USER_PROMO_MERCHANTS: Record<number, NewUserPromoDetail> = {
  100153743: {
    merchantId: 100153743,
    promoId: 'b842c5ad',
    region: Country.US,
    offerName: 'Afterpay x Buckle Promotional Offer Terms and Conditions',
    discountAmount: '20',
    minimumSpend: '25',
  },
  100108301: {
    merchantId: 100108301,
    promoId: '09246516',
    region: Country.US,
    offerName: 'Afterpay x Marleylilly Promotional Offer Terms and Conditions',
    discountAmount: '20',
    minimumSpend: '25',
  },
  100100017: {
    merchantId: 100100017,
    promoId: 'e4c57925',
    region: Country.US,
    offerName: 'Afterpay x Anthropologie Promotional Offer Terms and Conditions',
    discountAmount: '20',
    minimumSpend: '25',
  },
  100101278: {
    merchantId: 100101278,
    promoId: '46043c27',
    region: Country.US,
    offerName: 'Afterpay x Sunglass Hut Promotional Offer Terms and Conditions',
    discountAmount: '25',
    minimumSpend: '30',
  },
  100122308: {
    merchantId: 100122308,
    promoId: 'cfab46e3',
    region: Country.US,
    offerName: 'Afterpay x Alfa Western Wear Promotional Offer Terms and Conditions',
    discountAmount: '20',
    minimumSpend: '25',
  },
  100126014: {
    merchantId: 100126014,
    promoId: 'fb48cf7a',
    region: Country.US,
    offerName: 'Afterpay x Yankee Candle Promotional Offer Terms and Conditions',
    discountAmount: '15',
    minimumSpend: '20',
  },
  100109875: {
    merchantId: 100109875,
    promoId: 'a9276fe2',
    region: Country.US,
    offerName: 'Afterpay x J Crew Promotional Offer Terms and Conditions',
    discountAmount: '20',
    minimumSpend: '25',
  },
  100107054: {
    merchantId: 100107054,
    promoId: 'ff3c9c71',
    region: Country.US,
    offerName: 'Afterpay x Tillys Promotional Offer Terms and Conditions',
    discountAmount: '15',
    minimumSpend: '35',
    startDate: 'Wed Jan 19 2022 08:00:00 GMT+0000',
    endDate: 'Mon Jan 31 2022 7:59:00 GMT+0000',
  },
  100106987: {
    merchantId: 100106987,
    promoId: '09ebdab2',
    region: Country.US,
    offerName: 'Afterpay x FragranceNet Promotional Offer Terms and Conditions',
    discountAmount: '20',
    minimumSpend: '35',
    startDate: 'Tue Jan 25 2022 08:00:00 GMT+0000',
    endDate: 'Mon Feb 21 2022 07:59:00 GMT+0000',
  },
  100105408: {
    merchantId: 100105408,
    promoId: '2bddd568',
    region: Country.US,
    offerName: 'Afterpay x Ruggable Promotional Offer Terms and Conditions',
    discountAmount: '25',
    minimumSpend: '30',
  },
  100103110: {
    merchantId: 100103110,
    promoId: '088b915a',
    region: Country.US,
    offerName: "Afterpay x Levi's Promotional Offer Terms and Conditions",
    discountAmount: '15',
    minimumSpend: '50',
  },
  100100001: {
    merchantId: 100100001,
    promoId: '8a49e6ed',
    region: Country.US,
    offerName: 'Afterpay x Princess Polly Promotional Offer Terms and Conditions',
    discountAmount: '20',
    minimumSpend: '25',
    startDate: 'Tue Jan 25 2022 23:00:00 GMT+0000',
    endDate: 'Mon Mar 1 2022 00:00:00 GMT+0000',
  },
  100106186: {
    merchantId: 100106186,
    promoId: '8692deb8',
    region: Country.US,
    offerName: 'Afterpay x Estee Lauder Promotional Offer Terms and Conditions',
    discountAmount: '10',
    minimumSpend: '20',
  },
  42528: {
    merchantId: 42528,
    promoId: 'd17e54fb',
    region: Country.AU,
    offerName: 'Golf Box New Customer Promotion',
    discountAmount: '20',
    minimumSpend: '50',
  },
  58431: {
    merchantId: 58431,
    promoId: 'db34a106',
    region: Country.AU,
    offerName: 'Asics New Customer Promotion',
    discountAmount: '10',
    minimumSpend: '30',
  },
  88235: {
    merchantId: 88235,
    promoId: '1d4a6639',
    region: Country.AU,
    offerName: 'Lancome New Customer Promotion',
    discountAmount: '10',
    minimumSpend: '30',
  },
  40426: {
    merchantId: 40426,
    promoId: '855a187a',
    region: Country.AU,
    offerName: 'PUMA New Customer Promotion',
    discountAmount: '10',
    minimumSpend: '30',
  },
  44805: {
    merchantId: 44805,
    promoId: '7278fba2',
    region: Country.AU,
    offerName: 'Snowys New Customer Promotion',
    discountAmount: '20',
    minimumSpend: '50',
  },
  138153: {
    merchantId: 138153,
    promoId: '69abe0e6',
    region: Country.AU,
    offerName: 'Afterpay x Mwave Promotional Offer Terms and Conditions',
    discountAmount: '15',
    minimumSpend: '50',
  },
  34776: {
    merchantId: 34776,
    promoId: '68285a68',
    region: Country.AU,
    offerName: 'Super Cheap Auto New Customer Promotion',
    discountAmount: '20',
    minimumSpend: '50',
  },
  60288: {
    merchantId: 60288,
    promoId: 'da03e5fa',
    region: Country.AU,
    offerName: 'Footlocker New Customer Promotion',
    discountAmount: '10',
    minimumSpend: '30',
  },
  44814: {
    merchantId: 44814,
    promoId: '19a42374',
    region: Country.AU,
    offerName: 'Fantastic Furniture New Customer Promotion',
    discountAmount: '20',
    minimumSpend: '50',
  },
  100149968: {
    merchantId: 100149968,
    promoId: 'a24f9720',
    region: Country.US,
    offerName: 'Afterpay x PetSmart Promotional Offer Terms and Conditions',
    discountAmount: '10',
    minimumSpend: '15',
  },
  100143492: {
    merchantId: 100143492,
    promoId: '2c6e15ff',
    region: Country.US,
    offerName: 'Afterpay x Dr. Martens Promotional Offer Terms and Conditions',
    discountAmount: '15',
    minimumSpend: '20',
  },
  96902: {
    merchantId: 96902,
    promoId: '214f6e29',
    region: Country.AU,
    offerName: 'Afterpay x Ticketek Promotional Offer Terms and Conditions',
    discountAmount: '15',
    minimumSpend: '50',
  },
  70364: {
    merchantId: 70364,
    promoId: '40afa2e8',
    region: Country.AU,
    offerName: 'Afterpay x Dyson Promotional Offer Terms and Conditions',
    discountAmount: '20',
    minimumSpend: '50',
  },
  32630: {
    merchantId: 32630,
    promoId: '288ccff6',
    region: Country.AU,
    offerName: 'Afterpay x Princess Polly Promotional Offer Terms and Conditions',
    discountAmount: '20',
    minimumSpend: '30',
    startDate: 'Tue Mar 01 2022 13:00:00 GMT+0000',
    endDate: 'Fri Mar 11 2022 12:59:00 GMT+0000',
  },
  100119448: {
    merchantId: 100119448,
    promoId: '004fe3e1',
    region: Country.US,
    offerName: 'Afterpay x Beautylish Promotional Offer Terms and Conditions',
    discountAmount: '15',
    minimumSpend: '20',
    startDate: 'Mon Feb 21 2022 08:00:00 GMT+0000',
    endDate: 'Tue Mar 22 2022 06:59:00 GMT+0000',
  },
  42747: {
    merchantId: 42747,
    promoId: 'c4257c25',
    region: Country.AU,
    offerName: 'Afterpay x Muscle Nation Promotional Offer Terms and Conditions',
    discountAmount: '15',
    minimumSpend: '30',
    startDate: 'Sun Feb 27 2022 13:00:00 GMT+0000',
    endDate: 'Wed Mar 09 2022 12:59:00 GMT+0000',
  },
}

export const QA_NEW_USER_PROMO_MERCHANTS: Record<number, NewUserPromoDetail> = {
  10: {
    merchantId: 10,
    promoId: '09ebdab2',
    region: Country.AU,
    offerName: 'Afterpay x Test Merchant Promotional Offer Terms and Conditions',
    discountAmount: '20',
    minimumSpend: '30',
    startDate: new Date().toString(),
    endDate: 'Mon Jul 1 2022 00:00:00 GMT+0000',
  },
  249643: {
    merchantId: 249643,
    promoId: '09ebdab2',
    region: Country.AU,
    offerName: 'Afterpay x Test Merchant Promotional Offer Terms and Conditions',
    discountAmount: '20',
    minimumSpend: '30',
    startDate: 'Tue Feb 15 2022 00:00:00 GMT+0000',
    endDate: 'Mon Mar 1 2022 00:00:00 GMT+0000',
  },
  600130022: {
    merchantId: 600130022,
    promoId: '288ccff6',
    region: Country.AU,
    offerName: 'Afterpay x Princess Polly Promotional Offer Terms and Conditions',
    discountAmount: '20',
    minimumSpend: '30',
    startDate: new Date().toString(),
    endDate: 'Mon Jul 1 2022 00:00:00 GMT+0000',
  },
  100136994: {
    merchantId: 100136994,
    promoId: '004fe3e1',
    region: Country.US,
    offerName: 'Afterpay x Dr. Martens Promotional Offer Terms and Conditions',
    discountAmount: '15',
    minimumSpend: '20',
    startDate: new Date().toString(),
    endDate: 'Mon Jul 1 2022 00:00:00 GMT+0000',
  },
}

export enum PromotionType {
  NEW_USER_PROMO = 'new-user-promo',
}
